// Package Dependencies
import { call, put, takeLatest } from 'redux-saga/effects'
// Additional Dependencies
import axios from '../../utility/Axios'
// Action Dependencies
import {
  LIST_RESOURCE_REQUEST,
  listResourceSuccess,
  listResourceFailure
} from '../../actions/Resource/Resource'

// Function Handle List Resource
function* handleListResource(action) {
  try {
    // Define Query Parameters
    const parameter = {
      version: '1.0.0'
    }
    // Define Endpoint - fetch all resources
    let endpoint = `/resource/${parameter.version}?limit=1000`

    // List Resource Request
    const response = yield call(axios.get_request, endpoint)
    // List Resource Success
    yield put(listResourceSuccess(response.data))
  } catch (error) {
    // List Resource Error
    yield put(listResourceFailure(error))
  }
}

// Export
export const ResourceSaga = [
  takeLatest(LIST_RESOURCE_REQUEST, handleListResource),
]